import { BUTTON_CELL_ACTION_DISPLAY_NAME } from "./core";
import createTestId from "../../../../fabrics/createTestId";

export const createTestIdForButtonCellActionElement = createTestId(
    BUTTON_CELL_ACTION_DISPLAY_NAME,
);
